import HttpService from "./httpService";

export const ADDRESS_VALIDATION_ENDPOINT = "/address/api/validate";

export const validateAddress = (
  httpService: HttpService,
  address: any
): Promise<any> =>
  httpService.post(
    ADDRESS_VALIDATION_ENDPOINT,
    { address },
    { "content-type": "application/json" }
  );
